import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { isDefined } from '@trimble-gcs/common';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';
import { PropertiesComponent } from '../../../../options-panel/selected-details/single-selected/properties/properties.component';
import { ViewerGlbComponent } from '../../../../options-panel/selected-details/single-selected/viewer-glb/viewer-glb.component';
// import { SetPreviewVisible } from '../../../../scandata/recycle-scandata/recycle-scandata.actions';
// import { RecycleScandataState } from '../../../../scandata/recycle-scandata/recycle-scandata.state';
import { ScandataModel } from '../../../../scandata/scandata.models';
import { singleSelectedTranslations } from './single-selected.translations';

@Component({
  selector: 'sd-recycle-bin-single-selected',
  standalone: true,
  imports: [
    CommonModule,
    ModusButtonModule,
    ModusIconModule,
    ModusTooltipModule,
    ViewerGlbComponent,
    PropertiesComponent,
  ],
  templateUrl: './single-selected.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectedComponent {
  readonly selectedScan = input.required<ScandataModel>();
  readonly previewVisible = input(true);
  readonly disabled = input(false);

  readonly closeClicked = output();
  readonly previewVisibleChanged = output<boolean>();

  readonly translations = singleSelectedTranslations();

  private readonly hasPreview = this.scanHasPreview();
  readonly showPreview = computed(() => this.hasPreview() && this.previewVisible());
  readonly previewButtonDisabled = computed(() => !this.hasPreview());
  readonly previewButtonTooltip = this.getPreviewButtonTooltip();

  togglePreview() {
    this.previewVisibleChanged.emit(!this.previewVisible());
  }

  private scanHasPreview() {
    return computed(() => {
      const previewUrl = this.selectedScan().previewUrl;
      const hasPreview = isDefined(previewUrl) && previewUrl.length > 0;
      return hasPreview;
    });
  }

  private getPreviewButtonTooltip() {
    return computed(() => {
      if (!this.hasPreview()) return this.translations.preview.notAvailable.text;

      return this.previewVisible()
        ? this.translations.preview.hide.text
        : this.translations.preview.show.text;
    });
  }
}
